// Pixel-art helpers ported from ai-office-prototype.html (px, drawPerson, avatar). Shared by the office canvas
// and every avatar in the chat, profile and lists.

// Status → label + light colour (the dot on the name tag, the monitor LED and the legend).
export const ST = {
  idle: { t: 'Free', c: '#5FB98A' },
  working: { t: 'Working', c: '#E3A33B' },
  waiting: { t: 'Needs you', c: '#E5566F' },
  talking: { t: 'Talking', c: '#59B7D6' },
  away: { t: 'Away', c: '#9AA3AF' },
  error: { t: 'Problem', c: '#E5566F' },
};
export const statusOf = (s) => ST[s] || ST.idle;

export function px(c, col, x, y, w, h) {
  c.fillStyle = col;
  c.fillRect(Math.round(x), Math.round(y), w, h);
}

const DEFAULT_LOOK = { shirt: '#2D9C9C', hair: '#2B1B12', skin: '#C48A60', long: false };
export const lookOf = (a) => ({ ...DEFAULT_LOOK, ...((a && a.look) || {}) });

// One 8×18 character. o: { frame, stand, walking, typing, talk, blink, mug }
export function drawPerson(c, x, y, look, o = {}) {
  const a = { ...DEFAULT_LOOK, ...look };
  const f = o.frame || 0;
  x = Math.round(x); y = Math.round(y);
  if (o.stand) {
    const s = o.walking ? f % 2 : 0;
    px(c, '#2E3440', x + 1, y + 14, 3, s ? 3 : 4); px(c, '#2E3440', x + 4, y + 14, 3, s ? 4 : 3);
    px(c, '#15181E', x + 1, y + (s ? 17 : 18), 3, 1); px(c, '#15181E', x + 4, y + (s ? 18 : 17), 3, 1);
  }
  px(c, a.shirt, x, y + 7, 8, 7); px(c, 'rgba(0,0,0,.15)', x, y + 13, 8, 1); px(c, a.skin, x + 3, y + 7, 2, 1);
  if (o.typing) {
    const u = f % 2;
    px(c, a.shirt, x - 1, y + 8, 1, 4); px(c, a.shirt, x + 8, y + 8, 1, 4);
    px(c, a.skin, x - 1, y + 12 - u, 1, 1); px(c, a.skin, x + 8, y + 11 + u, 1, 1);
  } else {
    px(c, a.shirt, x - 1, y + 8, 1, 5); px(c, a.shirt, x + 8, y + 8, 1, 5);
    px(c, a.skin, x - 1, y + 13, 1, 1); px(c, a.skin, x + 8, y + 13, 1, 1);
  }
  px(c, a.skin, x + 1, y + 1, 6, 6);
  px(c, a.hair, x, y, 8, 2); px(c, a.hair, x, y + 2, 1, a.long ? 8 : 3); px(c, a.hair, x + 7, y + 2, 1, a.long ? 8 : 3); px(c, a.hair, x + 1, y + 2, 2, 1);
  if (!o.blink) { px(c, '#15181E', x + 2, y + 4, 1, 1); px(c, '#15181E', x + 5, y + 4, 1, 1); }
  if (o.talk && f % 2) px(c, '#7A3B2E', x + 3, y + 6, 2, 1);
  if (o.mug) { px(c, '#F2F2F2', x + 8, y + 10, 2, 3); px(c, '#6B4A2E', x + 8, y + 10, 2, 1); }
}

// 12×12 avatar as a data URL, cached per look.
const AVC = {};
export function avatarUrl(agent) {
  const a = lookOf(agent);
  const k = [a.shirt, a.hair, a.skin, a.long ? 1 : 0].join('|');
  if (AVC[k]) return AVC[k];
  const c = document.createElement('canvas');
  c.width = 12; c.height = 12;
  const g = c.getContext('2d');
  px(g, '#C9D3DC', 0, 0, 12, 12);
  drawPerson(g, 2, 2, a, {});
  AVC[k] = c.toDataURL();
  return AVC[k];
}
